import React from 'react';

interface LoadingSkeletonProps {
  rows?: number;
  showTitle?: boolean;
  titleWidth?: string;
  labelWidth?: string;
  className?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  rows = 5,
  showTitle = true,
  titleWidth = 'w-1/3',
  labelWidth = 'w-1/4',
  className = '',
}) => {
  return (
    <section className={`bg-white rounded w-full grow p-8 ${className}`}>
      <div className="animate-pulse">
        {showTitle && <div className={`h-8 bg-gray-200 rounded ${titleWidth} mb-4`}></div>}
        <div className="space-y-4">
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i}>
              <div className={`h-4 bg-gray-200 rounded ${labelWidth} mb-2`}></div>
              <div className="h-10 bg-gray-200 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LoadingSkeleton;
